import React from 'react';
import PropTypes from 'prop-types';
import AvailableLanguageLink from '../AvailableLanguageLink';
import { Link } from 'src/components/Inputs';

const propTypes = {
  id: PropTypes.string,
  availableLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

const NlVersion = ({ id, availableLanguages }) => {
  return (
    <>
      <h4
        id={id || 'privacyverklaring'}
        data-magellan-target={id || 'privacyverklaring'}
      >
        Alle doelgroepen <br />
        Privacyverklaring
      </h4>

      <p>Beschikbare talen:</p>
      <ul>
        {availableLanguages.map((language, i) => {
          return (
            <AvailableLanguageLink
              key={`language-${i}`}
              href={language.href}
              label={language.label}
            />
          );
        })}
      </ul>
      <br />
      <br />

      <p>Ingangsdatum: 22 februari 24</p>
      <p>
        Hartelijk dank dat u Plaid gebruikt! We hopen dat u de tijd neemt om
        deze Privacyverklaring zorgvuldig te lezen.
      </p>
      <p>
        Deze Privacyverklaring zet de manieren uiteen waarop Plaid Inc. en haar
        dochterondernemingen, waaronder Plaid Financial Ltd., Plaid Consumer
        Reporting Agency, Inc. en Plaid, B.V. (gezamenlijk “Plaid”, “we/wij”,
        “onze” en “ons”) gegevens over u (d.w.z. de ontwikkelaar, klant,
        websitebezoeker) verzamelen, gebruiken en delen wanneer u de websites
        van Plaid bezoekt of gebruikt, onze producten en diensten gebruikt in uw
        softwaretoepassing opneemt of anderszins met ons communiceert
        (bijvoorbeeld wanneer u een klantenservice-aanvraag doet of een
        Plaid-evenement of webinar bijwoont). Deze Privacyverklaring is niet van
        toepassing op gegevens die we verzamelen over eindgebruikers wanneer ze
        hun financiële rekeningen via Plaid koppelen aan een app of op de
        gegevens die worden gebruikt om een Plaid CRA-consumentenrapport te
        maken. Als u op zoek bent naar informatie over hoe we omgaan met
        gegevens die onder die omstandigheden zijn verzameld, raadpleeg dan ons{' '}
        <Link href='#privacybeleid-voor-eindgebruikers'>
          <a>Privacybeleid voor eindgebruikers</a>
        </Link>{' '}
        of{' '}
        <Link href='/plaid-check-consumer-report/privacy-policy/'>
          <a>Privacybeleid voor Plaid Consumer Reporting Agency</a>
        </Link>
        .
      </p>
      <p>
        <em>Spring naar onderdeel:</em>
      </p>
      <p>
        <Link href='#hoe-wij-omgaan-met-gegevens-1'>
          {/* add 1 because this hash also exists in eupp */}
          <a data-smooth-scroll data-offset='80'>
            Hoe wij omgaan met gegevens
          </a>
        </Link>
      </p>

      <ul data-smooth-scroll data-offset='80'>
        <li>
          <p>
            <Link href='#gegevens-die-we-verzamelen-en-categorieën-bronnen'>
              <a>Gegevens die we verzamelen en categorieën bronnen</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#hoe-we-uw-gegevens-gebruiken-privacyverklaring'>
              <a>Hoe we uw gegevens gebruiken</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#onze-wettelijke-grondslagen-voor-verwerking-privacyverklaring'>
              <a>
                Onze wettelijke grondslagen voor verwerking in de EER en het VK
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#hoe-we-uw-gegevens-delen-privacyverklaring'>
              <a>Hoe we uw gegevens delen</a>
            </Link>
          </p>
        </li>
      </ul>

      <p>
        <Link href='#overige-details-privacyverklaring'>
          <a data-smooth-scroll data-offset='80'>
            Overige details
          </a>
        </Link>
      </p>
      <ul data-smooth-scroll data-offset='80'>
        <li>
          <p>
            <Link href='#chatbots-advertenties-analyse-en-andere-diensten-geleverd-door-derden'>
              <a>
                {' '}
                Chatbots, advertenties, analyse- en andere diensten geleverd
                door derden
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#internationale-gegevensoverdrachten-privacyverklaring'>
              <a>Internationale gegevensoverdrachten</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#bewaren-van-gegevens-privacyverklaring'>
              <a>Bewaren van gegevens</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#uw-keuzes-privacyverklaring'>
              <a>Uw keuzes</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#uw-gegevensbeschermingsrechten'>
              <a>Uw gegevensbeschermingsrechten</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#wijzigingen-in-deze-verklaring-privacyverklaring'>
              <a>Wijzigingen in deze Verklaring</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#contact-opnemen-met-plaid-privacyverklaring'>
              <a>Contact opnemen met Plaid</a>
            </Link>
          </p>
        </li>
      </ul>
      <br />
      <br />

      <h4 id='hoe-wij-omgaan-met-gegevens-1'>Hoe wij omgaan met gegevens</h4>
      <h5 id='gegevens-die-we-verzamelen-en-categorieën-bronnen'>
        Gegevens die we verzamelen en categorieën bronnen
      </h5>
      <p>
        <strong>Gegevens die u aan ons verstrekt</strong>. We verzamelen de
        gegevens die u rechtstreeks aan Plaid verstrekt. U verstrekt
        bijvoorbeeld persoonsgegevens wanneer u een ontwikkelaarsaccount
        aanmaakt, ons ‘contactformulier’ invult, zich aanmeldt voor onze
        e-mails, klantenondersteuning aanvraagt, zich inschrijft voor
        facturering, of anderszins met ons communiceert. De soorten gegevens die
        we verzamelen zijn onder andere:
      </p>
      <ul>
        <li>
          <p>
            identificatiegegevens (zoals volledige naam, e-mailadres, postadres,
            telefoonnummer en geboortedatum),
          </p>
        </li>
        <li>
          <p>
            gevoelige gegevens (zoals een rijbewijsnummer en fiscaal
            identificatienummer, financiële rekeninginformatie en
            burgerservicenummers, waar nodig om diensten te verlenen),
          </p>
        </li>
        <li>
          <p>beroepsgegevens (zoals een bedrijfsnaam en -titel), en</p>
        </li>
        <li>
          <p>
            alle andere persoonsgegevens die u verstrekt (waaronder bijvoorbeeld
            in ondersteuningsberichten voor ontwikkelaars).
          </p>
        </li>
      </ul>
      <p>
        We kunnen ook bepaalde documentatie verzamelen die uw foto bevat of we
        kunnen van u eisen dat u uw identiteit verifieert door een foto of video
        van uzelf te verstrekken. Gegevens die in dit verband worden verzameld,
        kunnen in sommige staten of landen als biometrische gegevens worden
        beschouwd, zoals hieronder vermeld. Zie hieronder de speciale
        kennisgeving voor inwoners van Illinois en Texas.
      </p>
      <p>
        <u>
          Speciale biometrische gegevensverklaring voor inwoners van Illinois en
          Texas
        </u>
      </p>
      <p>
        Voor inwoners van Illinois of Texas, als we vereisen dat u ons een
        document verstrekt met uw foto of als u uw identiteit moet verifiëren
        door een foto of video van uzelf te verstrekken, kunnen de gegevens die
        zijn afgeleid van uw gezicht die wij en onze dienstverleners namens ons
        verzamelen en verwerken, op sommige plaatsen worden beschouwd als
        biometrische gegevens. Uw gegevens worden niet langer dan drie jaar
        bewaard, tenzij wettelijk vereist.
      </p>
      <p>
        <strong>
          Gegevens die we ontvangen wanneer u onze technologie test
        </strong>
        . Soms gebruiken mensen die toepassingen bouwen met behulp van onze
        diensten hun eigen inloggegevens voor hun bankrekening of andere
        financiële rekening om te testen en te evalueren hoe onze technologie in
        hun toepassing zal verschijnen en functioneren. Als u dit doet, moet u
        ons{' '}
        <Link href='#privacybeleid-voor-eindgebruikers'>
          <a>Privacybeleid voor eindgebruikers</a>
        </Link>{' '}
        lezen voor details over hoe we die gegevens verzamelen en verwerken.
      </p>
      <p>
        <strong>
          Gegevens die we verzamelen wanneer u gebruikmaakt van onze diensten
        </strong>
        . Wanneer u gebruikmaakt van onze diensten, verzamelen we de volgende
        gegevens over u:
      </p>
      <ul>
        <li>
          <p>
            <strong>Loggegevens</strong>: We verzamelen logbestanden wanneer u
            onze diensten gebruikt. Dit omvat identificatoren en elektronische
            informatie over netwerkactiviteiten, zoals het type browser dat u
            gebruikt, wanneer u onze diensten opent, de bekeken pagina’s en uw
            IP-adres.
          </p>
        </li>
        <li>
          <p>
            <strong>Geschatte locatie</strong>: We bepalen bij benadering de
            locatie van het apparaat dat u gebruikt om toegang te krijgen tot
            onze diensten vanaf uw IP-adres of tijdzone-instelling op uw
            apparaat.
          </p>
        </li>
        <li>
          <p>
            <strong>
              Gegevens verzameld door cookies en andere trackingtechnologieën
            </strong>
            : We gebruiken verschillende technologieën zoals cookies en
            webbakens in onze diensten om persoonsgegevens te verzamelen.
            Cookies zijn kleine gegevensbestanden die door uw webbrowser, op uw
            harde schijf of in het geheugen van uw apparaat worden opgeslagen en
            die ons helpen onze Diensten en uw ervaring te verbeteren, het
            gebruik van onze Diensten te bepalen en potentieel schadelijk gedrag
            te controleren en te detecteren. Webbakens zijn elektronische
            afbeeldingen die worden gebruikt in onze Diensten of e-mails en
            helpen bij het leveren van cookies. Webbakens tellen hoe vaak een
            webpagina wordt bezocht en helpen ons te begrijpen hoe onze Dienst
            wordt gebruikt en helpen ons onze Dienst te verbeteren.
          </p>
          <ul>
            <li>
              <p>
                Houd er rekening mee dat we cookies van derden kunnen gebruiken
                voor onze advertentiedoeleinden, zoals toegestaan door de wet en
                zoals verder beschreven in ons{' '}
                <Link href='#cookiebeleid'>
                  <a>Cookiebeleid</a>
                </Link>
                . Om uw cookie-instellingen en -voorkeuren te wijzigen,
                inclusief die voor targeting- en advertentiecookies, klikt u op
                de link Cookievoorkeuren in de voettekst van de pagina.
              </p>
            </li>
          </ul>
        </li>
      </ul>
      <p>
        <strong>Gegevens die we verzamelen uit andere bronnen</strong>. Wij
        verzamelen ook gegevens over u uit andere bronnen. We kunnen
        bijvoorbeeld gegevens verzamelen van andere leden van uw bedrijf en van
        leveranciers die ons helpen nieuwe zakelijke klanten te identificeren,
        waaronder uw naam, e-mailadres en URL van uw sociale media-profiel.
      </p>

      <h5 id='hoe-we-uw-gegevens-gebruiken-privacyverklaring'>
        Hoe we uw gegevens gebruiken
      </h5>
      <p>
        We gebruiken de gegevens die we verzamelen voor de volgende zakelijke en
        commerciële doeleinden:
      </p>
      <ul>
        <li>
          <p>
            voor het exploiteren, verbeteren en ontwikkelen van onze diensten;
          </p>
        </li>
        <li>
          <p>Om uw identiteit te verifiëren;</p>
        </li>
        <li>
          <p>
            Om ontwikkelaars te factureren voor onze diensten en hen te betalen;
          </p>
        </li>
        <li>
          <p>
            Om te voldoen aan de wet, zoals het doen van belastingaangiftes;
          </p>
        </li>
        <li>
          <p>
            Om u zaken te sturen zoals technische kennisgevingen, updates,
            beveiligingswaarschuwingen en berichten over uw account;
          </p>
        </li>
        <li>
          <p>
            Om te reageren op uw opmerkingen, vragen en verzoeken om
            klantenservice;
          </p>
        </li>
        <li>
          <p>Om uw ervaring met onze diensten persoonlijker te maken;</p>
        </li>
        <li>
          <p>
            Om met u te communiceren over producten, diensten, aanbiedingen en
            Plaid-evenementen die wij aanbieden of sponsoren;
          </p>
        </li>
        <li>
          <p>
            Om trends, gebruik en activiteiten in verband met onze diensten te
            monitoren en te analyseren;
          </p>
        </li>
        <li>
          <p>
            Om fraude, kwaadaardige activiteiten en andere illegale activiteiten
            op te sporen en te voorkomen;
          </p>
        </li>
        <li>
          <p>
            Om de rechten, privacy, veiligheid of eigendom van Plaid en anderen
            te beschermen; en
          </p>
        </li>
        <li>
          <p>
            Voor andere doeleinden waarover we u informeren vóór of op het
            moment dat we de gegevens verzamelen.
          </p>
        </li>
      </ul>

      <h5 id='onze-wettelijke-grondslagen-voor-verwerking-privacyverklaring'>
        Onze wettelijke grondslagen voor verwerking in de EER en het VK
      </h5>
      <p>
        Plaid verwerkt uw persoonsgegevens alleen wanneer we een geldige
        rechtsgrond hebben om dit te doen. Onze rechtsgrond voor het verwerken
        van de gegevens die we verzamelen, hangt af van het soort gegevens dat
        we hebben verzameld en de context voor het verwerken ervan. Over het
        algemeen verzamelen en verwerken we alleen gegevens wanneer:
      </p>
      <ul>
        <li>
          <p>
            we moeten voldoen aan onze verantwoordelijkheden en verplichtingen
            in een contract of overeenkomst met u;
          </p>
        </li>
        <li>
          <p>
            om te voldoen aan onze wettelijke verplichtingen volgens
            toepasselijk recht;
          </p>
        </li>
        <li>
          <p>
            indien de verwerking noodzakelijk is in verband met onze
            gerechtvaardigde belangen, en uw gegevensbeschermingsrechten of
            fundamentele rechten en vrijheden niet zwaarder wegen dan die
            belangen (bijvoorbeeld om onze diensten te kunnen verlenen of
            actualiseren); en
          </p>
        </li>
        <li>
          <p>u hiervoor uw toestemming hebt gegeven.</p>
        </li>
      </ul>

      <h5 id='hoe-we-uw-gegevens-delen-privacyverklaring'>
        Hoe we uw gegevens delen
      </h5>
      <p>We delen gegevens over u als volgt:</p>
      <ul>
        <li>
          <p>
            Met andere bedrijven of personen zoals dienstverleners, aannemers of
            zakenpartners om diensten voor ons te verlenen en ons bedrijf te
            helpen ondersteunen. We delen ook gegevens met incassobureaus in het
            geval van achterstallige betalingen van onze ontwikkelaars.
          </p>
        </li>
        <li>
          <p>
            Als we te goeder trouw geloven dat openbaarmaking gepast is om te
            voldoen aan de toepasselijke wet- en regelgeving of juridische
            procedures (zoals een gerechtelijk bevel of dagvaarding). Dit omvat
            openbaarmaking in verband met verzoeken van
            wetshandhavingsinstanties of andere overheidsinstanties;
          </p>
        </li>
        <li>
          <p>
            Als wij van mening zijn dat uw handelingen niet in overeenstemming
            zijn met onze overeenkomsten of beleidslijnen, of om de rechten,
            privacy, veiligheid of eigendom van Plaid of anderen te beschermen;
          </p>
        </li>
        <li>
          <p>
            In het geval van een verandering in eigendom of controle van ons
            hele bedrijf of een deel daarvan (zoals een fusie, overname,
            reorganisatie of faillissement);
          </p>
        </li>
        <li>
          <p>
            Tussen Plaid en onze huidige en toekomstige moedermaatschappijen,
            gelieerde ondernemingen, dochterondernemingen en andere bedrijven
            onder gezamenlijke controle of eigendom; en
          </p>
        </li>
        <li>
          <p>Met uw toestemming of op uw aanwijzing.</p>
        </li>
      </ul>
      <p>
        We verzamelen, gebruiken en delen ook gegevens die zijn geaggregeerd en
        geanonimiseerd op een manier die niet kan worden gebruikt om u te
        identificeren, voor enig doel dat is toegestaan onder de toepasselijke
        wetgeving.
      </p>
      <p>
        We delen mogelijk persoonsgegevens met derden of staan hen toe
        persoonsgegevens te verzamelen van onze sites of diensten, zoals
        hierboven beschreven.
      </p>
      <p>
        In deze tabel wordt uitgelegd hoe we in de afgelopen 12 maanden
        persoonsgegevens hebben verzameld en gedeeld:
      </p>
      <br />

      <p>CATEGORIEËN PERSOONSGEGEVENS</p>

      <div className='all-audiences-container'>
        <table className='all-audiences-table'>
          <thead>
            <tr>
              <td>
                <p>Categorieën persoonsgegevens</p>
              </td>
              <td>
                <p>Bron persoonsgegevens</p>
              </td>
              <td>
                <p>Gebruik persoonsgegevens </p>
                <p>
                  (zie hierboven voor meer informatie over de gebruikssituaties
                  waarnaar hieronder wordt verwezen)
                </p>
              </td>
              <td>
                <p>
                  Categorieën van partijen met wie persoonsgegevens kunnen
                  worden gedeeld
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <ul>
                  <li>
                    <p>Identificatiemiddelen</p>
                  </li>
                  <li>
                    <p> Financiële gegevens</p>
                  </li>
                  <li>
                    <p>Commerciële gegevens </p>
                  </li>
                  <li>
                    <p> Locatiegegevens</p>
                  </li>
                  <li>
                    <p>Beroep gerelateerde gegevens</p>
                  </li>
                  <li>
                    <p>Gegevens over elektronische netwerkactiviteiten</p>
                  </li>
                  <li>
                    <p>Gevoelige gegevens</p>
                  </li>
                  <li>
                    <p>Afgeleiden</p>
                  </li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>
                    <p>Gegevens die u verstrekt</p>
                  </li>
                  <li>
                    <p>Gegevens die we ontvangen vanaf uw apparaten</p>
                  </li>
                  <li>
                    <p>
                      Gegevens die we over u ontvangen uit andere bronnen, dan
                      die welke hierboven beschreven
                    </p>
                  </li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>
                    <p>Diensten verlenen</p>
                  </li>
                  <li>
                    <p>Diensten verbeteren</p>
                  </li>
                  <li>
                    <p>Fraude voorkomen en privacy en beveiliging beschermen</p>
                  </li>
                  <li>
                    <p>Ondersteuning bieden</p>
                  </li>
                  <li>
                    <p>Misbruik en overtredingen onderzoeken</p>
                  </li>
                  <li>
                    <p>Voldoen aan wettelijke verplichtingen</p>
                  </li>
                  <li>
                    <p>Met uw toestemming</p>
                  </li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>
                    <p>
                      Dienstverleners die Plaid helpen bij het analyseren van
                      gegevens voor zakelijke doeleinden{' '}
                    </p>
                  </li>
                  <li>
                    <p>Aanbieders van gebruikersonderzoek en enquêtes</p>
                  </li>
                  <li>
                    <p>
                      Aanbieders van interne samenwerkings- en communicatietools
                    </p>
                  </li>
                  <li>
                    <p>Aanbieders van e-maildiensten</p>
                  </li>
                  <li>
                    <p>
                      Aanbieders van klantenrelatiebeheer en sales enablement
                    </p>
                  </li>
                  <li>
                    <p>Aanbieders van evenementenbeheer en -hosting</p>
                  </li>
                  <li>
                    <p>Aanbieders van klantenondersteuningsdiensten</p>
                  </li>
                  <li>
                    <p>Aanbieders van leadgeneratie</p>
                  </li>
                  <li>
                    <p>Aanbieders van documentbeheerdiensten</p>
                  </li>
                  <li>
                    <p>Aanbieders van cloudopslag en datawarehousing</p>
                  </li>
                  <li>
                    <p>Aanbieders van betaaldiensten</p>
                  </li>
                  <li>
                    <p>
                      Aanbieders van fraudebestrijding, identiteitsverificatie
                      en beveiligingsdiensten
                    </p>
                  </li>
                  <li>
                    <p>Aanbieders van softwareontwikkelingsdiensten</p>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h4 id='overige-details-privacyverklaring'>Overige details</h4>
      <h5 id='chatbots-advertenties-analyse-en-andere-diensten-geleverd-door-derden'>
        Chatbots, advertenties, analyse- en andere diensten geleverd door derden
      </h5>
      <p>
        We staan derden, waaronder Google Analytics, toe om analysediensten en
        advertenties op onze websites te leveren. Deze derden gebruiken cookies,
        webbakens en andere technologieën om gegevens over u te verzamelen.
        Plaid gebruikt chatbots die worden aangedreven door externe
        dienstverleners. Houd er rekening mee dat als u persoonsgegevens aan
        onze chatbot verstrekt, uw gegevens kunnen worden gedeeld met de externe
        dienstverlener om de chatbot te ondersteunen.
      </p>
      <p>
        Meer informatie over hoe we cookies gebruiken en uw gerelateerde keuzes
        vindt u in ons{' '}
        <Link href='#cookiebeleid'>
          <a>Cookiebeleid</a>
        </Link>
        .
      </p>

      <h5 id='internationale-gegevensoverdrachten-privacyverklaring'>
        Internationale gegevensoverdrachten
      </h5>
      <p>
        We kunnen de gegevens die we over u verzamelen, overdragen naar andere
        landen dan het land waarin u woont voor verwerking en opslag. Als we
        gegevens overdragen naar een land of gebied dat niet wordt geacht
        privacy- en gegevensbeschermingswetten te hebben die gelijk zijn aan die
        van uw land, zullen we dergelijke gegevens overdragen in overeenstemming
        met de toepasselijke gegevensbeschermingswetten. In het bijzonder kunnen
        we gebruikmaken van door de Europese Commissie goedgekeurde of door de
        Britse Secretary of State goedgekeurde (indien van toepassing)
        standaardcontractbepalingen, indien nodig in combinatie met aanvullende
        waarborgen. U kunt om een kopie van deze standaardcontractbepalingen
        vragen door contact op te nemen zoals hieronder uiteengezet.
      </p>
      <h5 id='bewaren-van-gegevens-privacyverklaring'>Bewaren van gegevens</h5>
      <p>
        We bewaren uw persoonsgegevens niet langer dan nodig is om de doeleinden
        te bereiken waarvoor ze zijn verzameld, tenzij een langere bewaartermijn
        is vereist onder de toepasselijke wetgeving.
      </p>

      <h5 id='uw-keuzes-privacyverklaring'>Uw keuzes</h5>
      <ul>
        <li>
          <p>
            <strong>Accountinformatie ontwikkelaar</strong>. U kunt gegevens die
            u ons verstrekt als onderdeel van uw online ontwikkelaarsaccount,
            bijwerken door in te loggen op uw account of door contact met ons op
            te nemen.
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies</strong>. Meer informatie over hoe we cookies
            gebruiken en uw gerelateerde keuzes vindt u in ons{' '}
            <Link href='#cookiebeleid'>
              <a>Cookiebeleid</a>
            </Link>
            .
          </p>
        </li>
        <li>
          <p>
            <strong>Marketingcommunicatie</strong>. U kunt zich afmelden voor
            het ontvangen van marketinge-mails van Plaid door de aanwijzingen in
            dergelijke e-mails te volgen. Als u zich afmeldt, kunnen we u nog
            steeds andere soorten e-mails sturen, zoals ondersteuning, service
            en andere e-mails over uw account of onze lopende zakelijke relatie.
          </p>
        </li>
      </ul>

      <h5 id='uw-gegevensbeschermingsrechten'>
        Uw gegevensbeschermingsrechten
      </h5>
      <p>
        U kunt rechten hebben met betrekking tot uw persoonsgegevens, waaronder
        het recht om te weten hoe we uw gegevens verzamelen, gebruiken of delen.
        Daarnaast hebt u mogelijk het recht om toegang te vragen tot uw
        persoonsgegevens, en om te vragen die gegevens bij te werken, te
        verwijderen of te corrigeren. Wij zullen uw verzoek om deze rechten uit
        te oefenen honoreren, ongeacht uw locatie. U wordt niet gediscrimineerd
        vanwege het uitoefenen van deze rechten.
      </p>
      <p>
        In bepaalde regio’s, waaronder de EER en het VK, hebt u mogelijk
        aanvullende rechten tot uw beschikking. Deze rechten omvatten het recht
        om: bezwaar te maken tegen verwerking van uw persoonsgegevens of te
        verzoeken om die verwerking te beperken; uw toestemming op elk moment in
        te trekken wanneer onze verwerking is gebaseerd op uw toestemming; en
        een klacht in te dienen bij uw lokale toezichthoudende autoriteit (als u
        zich in de EER bevindt, zie{' '}
        <Link href='https://edpb.europa.eu/about-edpb/board/members_nl'>
          <a>https://edpb.europa.eu/about-edpb/board/members_nl</a>
        </Link>{' '}
        en als u zich in het Verenigd Koninkrijk bevindt, zie{' '}
        <Link href='https://ico.org.uk/'>
          <a>www.ico.org.uk</a>
        </Link>{' '}
        voor contactgegevens).
      </p>
      <p>
        Voor zowel Plaid Financial Ltd. als Plaid, B.V. hebben wij een
        functionaris voor gegevensbescherming (DPO) aangesteld, die ook
        verantwoordelijk is voor het toezicht op vragen met betrekking tot dit
        Beleid en waarmee contact kan worden opgenomen via e-mail op{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>
        .
      </p>
      <p>
        Als u een inwoner van Californië bent, kunnen, behoudens beperkingen en
        uitzonderingen die door de wet worden bepaald, sommige aanvullende
        rechten voor u beschikbaar zijn onder de California Consumer Protection
        Act (“CCPA”) en zoals gewijzigd door de California Privacy Rights Act. U
        kunt ook: verzoeken om toegang tot de categorieën en specifieke
        onderdelen van persoonsgegevens die in de afgelopen twaalf maanden over
        u zijn verzameld (inclusief persoonsgegevens die voor zakelijke
        doeleinden openbaar zijn gemaakt); in kennis gesteld worden of uw
        persoonsgegevens zijn "verkocht" of "gedeeld" en aan wie; u afmelden
        voor "verkopen" of "delen" van uw persoonsgegevens als een bedrijf
        betrokken is bij het "verkopen" of "delen" van uw gegevens; en verzoeken
        om correctie door een bedrijf van onnauwkeurige persoonsgegevens. Houd
        er rekening mee dat we uw persoonsgegevens weliswaar niet verkopen, maar
        deze mogelijk delen met derden voor reclamedoeleinden met behulp van
        "cookies" zoals beschreven in ons cookiebeleid.
      </p>
      <p>
        Zoals hierboven onder "Uw keuzes" is uiteengezet, kunt u, als u een van
        onze ontwikkelaars bent, uw onlineaccountgegevens inzien door in te
        loggen op uw account. Om uw gegevensbeschermingsrechten, indien van
        toepassing, anderszins uit te oefenen, kunt u contact met ons opnemen
        zoals beschreven in het onderstaande gedeelte “Contact opnemen met
        Plaid”. Mogelijk moet u aanvullende informatie verstrekken om uw
        identiteit te bevestigen voordat we op uw verzoek kunnen reageren.
      </p>
      <p>
        Als we uw verzoek ontvangen van een bevoegde agent, kunnen we om bewijs
        vragen dat u de agent geldige schriftelijke bevoegdheid hebt gegeven om
        namens u verzoeken in te dienen. Als u een bevoegde agent bent die een
        verzoek wil indienen, neem dan contact met ons op zoals beschreven in
        het gedeelte “Contact opnemen met Plaid” hieronder.
      </p>

      <h5 id='wijzigingen-in-deze-verklaring-privacyverklaring'>
        Wijzigingen in deze Verklaring
      </h5>
      <p>
        We kunnen deze Privacyverklaring periodiek bijwerken of wijzigen. Als we
        updates of wijzigingen aanbrengen, wijzigen we de ingangsdatum bovenaan
        deze Verklaring. We kunnen u ook op andere manieren op de hoogte stellen
        van eventuele wijzigingen, zoals het plaatsen van een kennisgeving op
        onze homepage op{' '}
        <Link href='https://plaid.com'>
          <a>https://plaid.com</a>
        </Link>{' '}
        of het sturen van een e-mail. Wij raden u aan deze Privacyverklaring
        steeds wanneer u de diensten opent of anderszins contact met ons heeft,
        te bekijken om op de hoogte te blijven van onze gegevensverwerkingen en
        de keuzes die u ter beschikking staan.
      </p>

      <h5 id='contact-opnemen-met-plaid-privacyverklaring'>
        Contact opnemen met Plaid
      </h5>
      <p>
        Als u vragen hebt over deze privacyverklaring of onze privacypraktijken
        in het algemeen, neem dan contact met ons op via{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>{' '}
        of per post naar:
      </p>
      <p>
        <em>Als u buiten de EER of het VK woont:</em>
      </p>
      <div className='ios-legal-address'>
        Plaid Inc. <br />
        Attn: Legal <br />
        PO Box 7775 #35278 <br />
        San Francisco, California 94120-7775, U.S.A.
      </div>
      <br />
      <p>
        Voor zowel Plaid Financial Ltd. als Plaid, B.V. hebben wij een
        functionaris voor gegevensbescherming (DPO) aangesteld, die ook
        verantwoordelijk is voor het toezicht op vragen met betrekking tot dit
        Beleid en waarmee contact kan worden opgenomen via e-mail op{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>
        .
      </p>
      <p>
        <br />
        <em>Als u in het VK woont:</em>
      </p>
      <div className='ios-legal-address'>
        Plaid Financial Ltd. <br />
        Attn: Legal <br />
        New Penderel House, 4th Floor <br />
        283-288 High Holborn <br />
        London, United Kingdom, WC1V 7HP
      </div>
      <p>
        <br />
        <em>Als u in de EER woont:</em>
      </p>
      <div className='ios-legal-address'>
        Plaid, B.V. <br />
        t.a.v.: Juridische afdeling
        <br />
        Muiderstraat 1 <br />
        1011 PZ Amsterdam <br />
        Nederland
      </div>

      <hr className='section-divider' />
    </>
  );
};

NlVersion.propTypes = propTypes;
export default NlVersion;
